<template>
	<div>
		<el-form
			ref="form"
			label-width="100px"
			:model="formData"
			:rules="rules"
			:disabled="disabled"
		>
			<el-form-item label="领用类型" prop="useType">
				<dict-select
					filterable
					@change="currStationChange"
					v-model="formData.useType"
					placeholder="请选择领用类型"
					default
					:body="{ type: 'useType' }"
				/>
			</el-form-item>

			<el-form-item label="领用对象" prop="useCode">
				<dict-select
					filterable
					v-model="formData.useCode"
					:url="urls[formData.useType] || urls[0]"
					:selectedLabel.sync="formData.useName"
					placeholder="请选择领用对象"
				></dict-select>
			</el-form-item>
		</el-form>
		<el-dialog
			v-el-dialog-drag
			append-to-body
			:visible.sync="backDialogVisible"
			width="30%"
		>
			<span>是否要保存更改</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="backDialogVisible = false" size="small"
					>取消</el-button
				>
				<el-button @click="close()" size="small">不保存</el-button>
				<el-button @click="save()" type="primary" size="small"
					>保存</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
	props: {
		disabled: Boolean,
		gasCardCode: String,
	},
	data() {
		return {
			backDialogVisible: false,
			formData: {},
			rules: {
				useType: [
					{
						required: true,
						message: '请选择领用类型',
						trigger: 'blur',
					},
				],
				useCode: [
					{
						required: true,
						message: '请输入领用对象名称',
						trigger: 'blur',
					},
				],
			},
			urls: {
				1: '/master/carrier/info/select',
				2: '/master/driver/info/select',
				3: '/master/vehicle/info/select',
				4: '/sys/user/select',
				5: '',
			},
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		getData() {
			if (!this.gasCardCode) return
			this.$api
				.masterGasCardDetailApi({
					gasCardCode: this.gasCardCode,
				})
				.then((res) => {
					this.formData = res.body
				})
		},
		async save() {
			const result = await validate.formValidate([this.$refs.form])
			if (!result) return (this.backDialogVisible = false)
			console.log('save', this.formData.useName)
			this.$api.masterGasCardLssuedApi(this.formData).then((res) => {
				this.$message({
					showClose: true,
					message: res.msg,
					type: 'success',
				})
				this.$emit('close')
				this.$emit('reload')
			})
		},
		cancel() {
			if (this.disabled) {
				this.close()
				return
			}
			this.backDialogVisible = true
		},
		close() {
			this.backDialogVisible = false
			this.$emit('close')
		},

		currStationChange() {
			this.formData.useCode = ''
		},
	},
}
</script>
